import React  from 'react';
import Popup from '../popups/popup';
import ConfirmCancellationModal from "./confirmCancellationModal";

class ConfirmCancellationPopup extends Popup {
    constructor(props) {
        super(props);

        this._hide = this._hide.bind(this);
    }
    static initPopup(props = {}) {
        props.stopAnimation ? props.stopAnimation() : null;
        Popup.initPopup.call(this, props);

        this.props = props;
    }

    _onPopupClose() {
        if (this.props.stopAnimation) {
            this.props.stopAnimation();
        }
    }

    _hide() {
        super._hide()
    }

    content() {
        const {appointmentId, logger } = this.props
        return <div className='confirm-cancel-popup-content'>
            <ConfirmCancellationModal appointmentId={appointmentId} logger={logger} onCloseModal={this._hide} />
        </div>;
    }
}

ConfirmCancellationPopup.defaultProps = {
    popupClassName: 'confirm-cancel-popup',
    single: true,
    modal: true,
    onPopupClose: function() {
        this._onPopupClose();
    }
};

export default ConfirmCancellationPopup
